import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	name		: "header-search",
	data() {
		return {
			showSearch	: false,
			showResult	: false,
			debounce	: null,
			searchData	: {
				lastResult	: [],
				courses		: []
			},
		};
	},
	computed	: {
		...mapGetters({
			openSearch			: `system/openSearch`,
			searchList			: `courses/searchList`,
			searchHistoryList	: `courses/searchHistoryList`,
		}),
	},
	created() {},
	methods		: {
		...mapActions({
			getSearch		: "courses/GET_SEARCH",
			setSearchHistory: "courses/SET_SEARCH_HISTORY",
			getSearchHistory: "courses/GET_SEARCH_HISTORY",
		}),
		...mapMutations({
			changeSearch	: "system/CHANGE_OPEN_SEARCH",
		}),
		clearInput() {
			this.$refs.headerSearchInput.value = "";
			
			this.getSearch();
		},
		closeHeaderSearch() {
			this.changeSearch(false);
			
			this.clearInput();
		},
		focusSearchInput() {
			this.$nextTick(function() {
				this.$refs.headerSearchInput.focus();
			});
		},
		async onChangeSearch(event) {
			//console.log('onChangeSearch:', event.target.value);
			
			//return;
			
			var value = event.target.value;
			
			clearTimeout(this.debounce);
			
			this.debounce = setTimeout(() => {
				if (value && value.length > 1) {
					this.getSearch(value);
				} else {
					this.getSearch();
				}
			}, 500);
		},
		async onClickItem(item) {
			const courseId = item.id;
			
			this.$router.push(`/courses/${item.slug}/dashboard`);
			
			await this.setSearchHistory({ courseId });
			await this.getSearchHistory();
			
			this.closeHeaderSearch();
		},
		async onClickSearchItem(item) {
			this.$router.push(`/courses/${item.slug}/dashboard`);
			
			this.closeHeaderSearch();
		},
	},
	async mounted() {
		await this.getSearchHistory();
	}
};
